import ApiService from '../../services/api.service';

/**
 * One shape for the employee/document calls, so the same screens serve the typing center
 * (a client's Employees tab) and the client portal (Employees page).
 * PORTAL-EMPLOYEES-AND-FEATURES.md §4.4.
 *
 *   list(page, size)            -> axios response, data.data = { content, totalElements } or an array
 *   documents(uid)              -> axios response, data.data = { groups: [...] }
 *   view(filePath)              -> axios blob response
 *   extract(file, typeCode)     -> axios response of the OCR extract
 *   create(payload)             -> axios response, data.data = { uid, reused }
 *   upload(uid, files, type, meta)
 *   remove(uid, groupId)        -> null when this side may not delete (portal: TC only)
 */
export const tcEmployeeApi = (orgId) => ({
  list: (page, size) => ApiService.getClientEmployees(orgId, page, size),
  documents: (uid) => ApiService.getClientEmployeeDocuments(orgId, uid),
  view: (filePath) => ApiService.viewClientEmployeeDocument(orgId, filePath),
  extract: (file, typeCode) => ApiService.extractDocument(file, 'GENERAL', typeCode),
  create: (payload) => ApiService.createClientEmployee(orgId, payload),
  upload: (uid, files, documentType, meta) => ApiService.uploadClientEmployeeDocuments(orgId, uid, files, documentType, meta),
  remove: (uid, groupId) => ApiService.deleteClientEmployeeDocumentVersion(orgId, uid, groupId),
});

export const portalEmployeeApi = {
  list: (page, size) => ApiService.getPortalEmployees(page, size),
  documents: (uid) => ApiService.getPortalEmployeeDocuments(uid),
  view: (filePath) => ApiService.viewPortalEmployeeDocument(filePath),
  extract: (file, typeCode) => ApiService.extractPortalDocument(file, 'GENERAL', typeCode),
  create: (payload) => ApiService.createOrReusePortalEmployee(payload),
  upload: (uid, files, documentType, meta) => ApiService.uploadPortalEmployeeDocuments(uid, files, documentType, meta),
  // Deleting a document version is typing-center only.
  remove: null,
};
